import React from 'react';
import residentialImg from '../../assets/img/BestArchitecture/Residential.png';
import commercialImg from '../../assets/img/BestArchitecture/Commercial.png';
import industrialImg from '../../assets/img/BestArchitecture/Industrial Sector.png';
import infrastructureImg from '../../assets/img/BestArchitecture/Urban.png';
import mechanicalImg from '../../assets/img/BestArchitecture/Interior Design.png';
import healthcareImg from '../../assets/img/BestArchitecture/Institutional Projects.png';

const CadDraftingIndustries = () => {
    const industries = [
        {
            title: "Residential Architecture",
            icon: residentialImg,
            features: [
                "Detailed floor plans, elevations, and 3D home models",
                "Interior layouts, remodeling plans, and custom home designs"
            ]
        },
        {
            title: "Commercial Buildings",
            icon: commercialImg,
            features: [
                "Offices, retail outlets, hotels, and warehouses",
                "Accurate CAD drawings for construction and permit approval"
            ]
        },
        {
            title: "Industrial & Manufacturing",
            icon: industrialImg,
            features: [
                "Machinery layouts, equipment assemblies, and process plants",
                "Technical drafting for fabrication, assembly, and mechanical systems"
            ]
        },
        {
            title: "Infrastructure & Civil Engineering",
            icon: infrastructureImg,
            features: [
                "Bridges, roads, urban planning, and site development plans",
                "Survey-based CAD drawings for construction and planning"
            ]
        },
        {
            title: "Mechanical & Product Design",
            icon: mechanicalImg,
            features: [
                "Components, assemblies, and 3D mechanical CAD models",
                "Prototyping support and accurate technical specifications"
            ]
        },
        {
            title: "Healthcare & Institutional Facilities",
            icon: healthcareImg,
            features: [
                "Hospitals, laboratories, and educational buildings",
                "Space planning, functional layouts, and detailed CAD documentation"
            ]
        }
    ];

    return (
        <section className="cad-industries-section">
            <div className="cad-industries-header">
                <h2 className="cad-industries-title">
                    <span className="text-primary">Industries We Serve –</span> CAD Drafting Solutions Across Sectors
                </h2>
                <p className="cad-industries-subtitle">
                    At Chudasama Outsourcing, our CAD drafting services cater to a wide range of industries, providing accurate, efficient, and editable 2D & 3D CAD models tailored to your specific sector.
                </p>
            </div>

            <div className="cad-industries-grid">
                {industries.map((item, index) => (
                    <div key={index} className="cad-industries-card">
                        <div className="cad-industries-icon-wrapper">
                            <img
                                src={item.icon.src || item.icon}
                                alt={item.title}
                            />
                        </div>
                        <h3 className="cad-industries-card-title">{item.title}</h3>
                        <ul className="cad-industries-list">
                            {item.features.map((feature, fIndex) => (
                                <li key={fIndex}>{feature}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CadDraftingIndustries;
